import React, { Component } from "react"
import { trackCustomEvent, OutboundLink } from "gatsby-plugin-google-analytics"

import { Container } from "./styled"

import * as Styled from "../Icons/styled"

class Address extends Component {
  render() {
    return (
      <>
        <Container>
          <div className="grid-container">
            <div>
              <h3>Segunda a Sexta, das 8:00 as 18:30hrs.</h3>

              <div>
                <h3>Goiânia - GO,</h3>
              </div>

              <div>
                <OutboundLink
                  onClick={e => {
                    trackCustomEvent({
                      category: "Custom Button",
                      action: "Click",
                      label: "Botao do Whatsapp",
                    })
                  }}
                  href="https://wa.me/5562991375293?text=Saudações!%20Solicito%20o%20seu%20atendimento."
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <h4>
                    Cel:(62) 99137-5293 <Styled.WhatsappWrapper />
                  </h4>
                </OutboundLink>
                <h4>
                  <Styled.EmailWrapper /> devwallace93@gmail.com
                </h4>
              </div>
            </div>
          </div>
        </Container>
      </>
    )
  }
}

export default Address
